import type { TFileDropzoneFile } from '@vlabs/monokit/features/file-with-detections-viewer/FileWithDetectionsViewer';

import { DETECTION_TYPES } from './constants';
import { fromAPI } from './transformers';
import type { TransformEstimationArgument, FromApiReturn } from './transformers';

export const detectOnImageRequest = async (
  imageFile: TFileDropzoneFile,
  detectionTypes: string[],
  estimateFace?: (file: File) => Promise<unknown>,
  estimateBody?: (file: File) => Promise<unknown>,
): Promise<FromApiReturn | []> => {
  let estimations: TransformEstimationArgument[] = [];
  if ((detectionTypes || []).includes(DETECTION_TYPES.FACES)) {
    // @ts-expect-error api response
    const { data } = await estimateFace(imageFile.raw);
    estimations = [...estimations, ...data.images_estimations[0].estimations];
  }
  if ((detectionTypes || []).includes(DETECTION_TYPES.BODIES)) {
    // @ts-expect-error api response
    const { data } = await estimateBody(imageFile.raw);
    estimations = [...estimations, ...data.images_estimations[0].estimations];
  }

  if (estimations && estimations.length > 0) {
    return fromAPI(estimations);
  }

  return [];
};
